
Vue.component('streamer-settings', {
    template: templates.streamersSettings,
    data() {
      return {
        model: {
            settings: {}
        }
      }
    },
    mounted() {
        const c = this;
        c.get();
    },
    methods: {
        get() {
            const c = this;
            let data = {};
      
            settingsService.get()
              .then(function (response) {
                for (let d of response.data) {
                  data[`${d.id}`] = d;
                }
                c.model.settings = data;

              })
              .catch(function (error) {
                //console.log(error);
              });
          },
          save(id) {
            const c = this;
            const data = c.model.settings[`${id}`];
      
            settingsService.save(data)
              .then(function (response) {
                utils.alert.error('Setting Saved');
              })
              .catch(function (error) {
                //console.log(error);
              });
          }
    }
  });